export const Header = () => {
    return (
        <>
        <header className="w-full bg-stone-400 text-gray-50 px-8 py-4 fixed top-0 z-50">
            <div className="flex justify-center items-center">
                <a href="/">
                    <h1 className="amatic-sc-bold text-3xl">F&L</h1>
                </a>
            </div>
        </header>
        <div className="relative mt-16"></div>
        </>
    )
}